export default __webpack_public_path__ + "static/media/wechat-2.b316c003.png";